"use client";

import { createContext } from "react";

import type { Appointment } from "../types/Appointment";

export type AppointmentsContextState = {
  appointments: Appointment[];
  upcomingAppointment: Appointment | null;
  startVideoCall: () => void;
  endVideoCall: () => void;
  isVideoCallActive: boolean;
  bookAppointment: (
    date: Date,
    onSuccess?: () => void,
    onError?: () => void,
  ) => void;
  availableAdvisor: {
    name: string;
    image?: string;
  } | null;
};

export const AppointmentsContext = createContext<
  AppointmentsContextState | undefined
>(undefined);
